/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: List
 * root Object
 * @constructor
 */
window.List = function() {
	this.length = 0;
};
$hxClasses['List'] = List;
/** @private @type {Array} */
List.__name__ = ["List"];

/**
 * map
 * Returns a new list where all elements have been converted
 * by the function [f].
 * *
 * --------------------- *
 *
 * @public
 * @this List
 * @param {Function}  f 
 * @return {List}
 */
List.prototype.map = function (f) {
	/** @type {List} */
	var b = new List();
	/** @type {Array} */
	var l = this.h;
	while (l != null) {
		/** @type {List.T} */
		var v = l[0];
		l = l[1];
		b.add(f(v));
	}
	return b;
};


/**
 * filter
 * Returns a list filtered with [f]. The returned list
 * will contain all elements [x] for which [f(x) = true].
 * *
 * --------------------- *
 *
 * public function filter( f : T -> Bool )
 * @public
 * @this List
 * @param {Function}  f 
 * @return {List}
 */
List.prototype.filter = function(f) {
	/** @type {List} */ 
	var l2 = new List();
	/** @type {Array} */ 
	var l = this.h;
	while(l != null) {
		/** @type {List.T} */ 
		var v = l[0];
		l = l[1];
		if(f(v)) l2.add(v);
	}
	return l2;
};


/**
 * Join the element of the list by using the separator [sep].

 * @public
 * @this List
 * @param {string}  sep 
 * @return {string}
 */
List.prototype.join = function(sep) {
	/** @type {StringBuf} */
	var  s = new StringBuf();
	/** @type {boolean} */ 
	var first = true;
	/** @type {Array} */
	var l = this.h;
	while(l != null) {
		if(first) first = false; else s.b += Std.string(sep);
		s.b += Std.string(l[0]);
		l = l[1];
	}
	return s.b;
};


/**
 * toString
 * Returns a displayable representation of the String.
 * *
 * --------------------- *
 *
 * $type TFun([],TInst(String,[]))
 * public function toString()
 * @public
 * @this List
 * @return {string}
 */
List.prototype.toString = function() {
	/** @type {StringBuf} */ 
	var s = new StringBuf();
	/** @type {boolean} */ 
	var first = true;
	/** @type {Array} */ 
	var l = this.h;
	s.b += Std.string("{");
	while(l != null) {
		if(first) first = false; else s.b += Std.string(", ");
		s.b += Std.string(Std.string(l[0]));
		l = l[1];
	}
	s.b += Std.string("}");
	return s.b;
};


/**
 * iterator
 * Returns an iterator on the elements of the list.
 * *
 * --------------------- *
 *
 * @public
 * @this List
 * @return {Iterator}
 */
List.prototype.iterator = function () {
	return {
		h: this.h, hasNext: function () {
			return this.h != null;
		}, next: function () {
			if (this.h == null) return null;
			var x = this.h[0];
			this.h = this.h[1];
			return x;
		}
	};
};


/**
 * remove
 * Remove the first element that is [== v] from the list.
 * Returns [true] if an element was removed, [false] otherwise.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => v, t => TInst(List.T,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this List
 * @param {List.T}  v 
 * @return {boolean}
 */
List.prototype.remove = function(v) {
	/** @type {Array} */ 
	var prev = null;
	/** @type {Array} */ 
	var l = this.h;
	while(l != null) {
		if(l[0] == v) {
			if(prev == null) this.h = l[1]; else prev[1] = l[1];
			if(this.q == l) this.q = prev;
			this.length--;
			return true;
		}
		prev = l;
		l = l[1];
	}
	return false;
};


/**
 * clear
 * Makes the list empty.
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * @public
 * @this List
 * @return {void}
 */
List.prototype.clear = function() {
	this.h = null;
	this.q = null;
	this.length = 0;
};


/**
 * isEmpty
 * Tells if a list is empty.
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Bool,[]))
 * @public
 * @this List
 * @return {boolean}
 */
List.prototype.isEmpty = function() {
	return this.h == null;
};


/**
 * pop
 * Removes the first element of the list and
 * returns it or simply returns null if the
 * list is empty.
 * *
 * --------------------- *
 *
 * $type TFun([],TType(Null,[TInst(List.T,[])]))
 * @public
 * @this List
 * @return {Null}
 */
List.prototype.pop = function() {
	if(this.h == null) return null;
	/** @type {Object} */ 
	var x = this.h[0];
	this.h = this.h[1];
	if(this.h == null) this.q = null;
	this.length--;
	return x;
};


/**
 * last
 * Returns the last element of the list, or null
 * if the list is empty.
 * *
 * --------------------- *
 *
 * $type TFun([],TType(Null,[TInst(List.T,[])]))
 * @public
 * @this List
 * @return {Null}
 */
List.prototype.last = function() {
	return this.q == null?null:this.q[0];
};


/**
 * first
 * Returns the first element of the list, or null
 * if the list is empty.
 * *
 * --------------------- *
 *
 * $type TFun([],TType(Null,[TInst(List.T,[])]))
 * @public
 * @this List
 * @return {Null}
 */
List.prototype.first = function() {
	return this.h == null?null:this.h[0];
};


/**
 * push
 * Push an element at the beginning of the list.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => item, t => TInst(List.T,[]), opt => false }],TEnum(Void,[]))
 * public function push( item : T )
 * @public
 * @this List
 * @param {List.T}  item 
 * @return {void}
 */
List.prototype.push = function(item) {
	/** @type {Array} */ 
	var x = [item,this.h];
	this.h = x;
	if(this.q == null) this.q = x;
	this.length++;
};


/**
 * add
 * Add an element at the end of the list.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => item, t => TInst(List.T,[]), opt => false }],TEnum(Void,[]))
 * public function add( item : T )
 * @public
 * @this List
 * @param {List.T}  item 
 * @return {void}
 */
List.prototype.add = function(item) {
	/** @type {Array} */
	var x = [item];
	if(this.h == null) this.h = x; else this.q[1] = x;
	this.q = x;
	this.length++;
};

/** @type {number} */
List.prototype.length = null;
/** @private @type {Array} */
List.prototype.q = null;
/** @private @type {Array} */
List.prototype.h = null;
/** @type {List} */
List.prototype.__class__ = List;
